export const SENSOR_WIDGET_COLORS = {
  ths: { connected: "#3B82F6", disconnected: "#93C5FD" },
  wls: { connected: "#22C55E", disconnected: "#86EFAC" },
} as const

export const SENSOR_TYPE_COLORS = {
  ths: SENSOR_WIDGET_COLORS.ths.connected,
  wls: SENSOR_WIDGET_COLORS.wls.connected,
} as const
